<template>
	<v-select
		v-model="model"
		:items="items"
		:label="label"
		:outlined="outlined"
		:dense="dense"
		item-text="name"
		item-value="id"
		:hide-details="hideDetails"
		:clearable="clearable"
		:loading="loading"
		:rules="rules"
		return-object
	></v-select>
</template>

<script>
import mixin from './mixin/main'
import { mapGetters, mapActions } from 'vuex'
export default {
	mixins: [mixin],
	computed: {
		...mapGetters('VehicleMarketRegion', [ 'items' ]),
	},
	methods: {
		...mapActions('VehicleMarketRegion', [ 'load' ]),
	},
}
</script>